import { useFeatureFlag } from '@vaptmenu/feature-flags-react';
import { useAuth } from '@/shared/hooks/useAuth';
import { useVaptAiAvailabilityStore } from './useVaptAiAvailability';

/** Flag por estabelecimento que libera a Vapt IA. Nasce desligada. */
export const VAPT_AI_FLAG = 'panel.vapt-ai';

/** Só quem mexe no cardápio conversa com o agente na v1. */
export const VAPT_AI_PERMISSION = 'catalog.write';

/**
 * A Vapt IA aparece para este usuário?
 *
 * São duas condições, e as duas precisam valer: a flag ligada para o
 * estabelecimento e a permissão de escrita no cardápio. Sem flag não existe
 * recurso; sem permissão o agente não teria ferramenta alguma para oferecer,
 * e um launcher que abre uma conversa inútil é pior que launcher nenhum.
 *
 * Isto é só o que aparece na tela. Quem de fato decide é o servidor, que
 * avalia as duas flags em todo endpoint e responde 404 quando desligadas —
 * e é esse 404 que o terceiro termo observa, para o launcher sumir sem
 * esperar a próxima leitura de flags.
 */
export function useVaptAiAvailable(): boolean {
  const flagEnabled = useFeatureFlag(VAPT_AI_FLAG);
  const { hasPermission, selectedTenant } = useAuth();
  const disabledTenantId = useVaptAiAvailabilityStore((state) => state.disabledTenantId);

  const refusedByServer = !!selectedTenant && disabledTenantId === selectedTenant.id;

  return flagEnabled && hasPermission(VAPT_AI_PERMISSION) && !refusedByServer;
}
